import { Spinner } from 'components/ui/general';

import { reactSelectComponents } from '../reactSelectComponents';

export const LoadingMessage = (props: any) => {
  return (
    <reactSelectComponents.LoadingMessage {...props}>
      <Spinner visible size="sm" />
    </reactSelectComponents.LoadingMessage>
  );
};
